/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import { MotifButton, MotifIcon } from "@ey-xd/motif-react";
import "./CTProductPreview.scss";
import { IconoirPlus } from "@ey-xd/motif-icon";
import CTProductPreviewCard from "../../components/CTProductPreviewCard/CTProductPreviewCard";
import Loader from "../../components/Loader";
import {
  customPaginationPageSize,
  customPaginationPageSizeSelector,
} from "../../Constant";
import { fetchSkuListData } from "../../store/slices/CTDBSkuListSlice";
import { useParams } from "react-router";
import { mapSkuListAPIDataWithFormFields } from "../CTProductCostSetup/Helper";
import {
  fetchProductDetailsData,
  resetProductDetailState,
} from "../../store/slices/CTDBProductDetailsSlice";
import NotificationGrid from "../../components/Notification/NotificationGrid";
import CreateSkuModal from "../CreateSku/CreateSkuModal";
import CustomPagination from "../../components/CustomPagination";
import UpdateSkuModal from "../CreateSku/UpdateSkuModal";
import { Toast } from "../../components/Toast/Toast";
import { ApiStatus } from "../../utils/apiStatus.enum";

const CTProductPreview = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [showCreateNewSkus, setShowCreateNewSkus] = useState(false);
  const [reloadOnNewCreation, setReloadOnNewCreation] = useState(false);
  const [showUpdateSkus, setShowUpdateSkus] = useState(false);
  const [selectedSku, setSelectedSku] = useState("");
  const [showSuccessPage, setShowSuccessPage] = useState(false);
  const paginationPageSize: number = customPaginationPageSize;
  const paginationPageSizeSelector: number[] = customPaginationPageSizeSelector;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [paginationObj, setPaginationObj] = useState<any>({
    currentPage: 1,
    pageSize: paginationPageSize,
    searchText: "",
    SortOrder: "",
    SortColumn: "",
  });

  const param = useParams();
  const productId = param.id;
  const isLoading = useSelector(
    (state: RootState) => state.CTDBSkuListSlice.isLoading
  );
  const apiData = useSelector(
    (state: RootState) => state.CTDBSkuListSlice.data
  );
  const error = useSelector((state: RootState) => state.CTDBSkuListSlice.error);

  const isLoadingproductDetailAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.isLoading
  );
  const productDetailsApi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.data
  );
  const errorproductDetailAPi = useSelector(
    (state: RootState) => state.CTDBProductDetailsSlice.error
  );

  const userPermissionsData: string[] = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissions,
  );

  const userEntityData = useSelector(
    (state: RootState) => state.UserProfileSlice.userEntityData,
  );

  const userPermissionsStatus: ApiStatus = useSelector(
    (state: RootState) => state.UserProfileSlice.userPermissionsStatus,
  );

  const userEmailInStore: string = useSelector(
    (state: RootState) => state.UserProfileSlice.emailId,
  );

  function scrollToBottom() {
    window.scrollTo({ top: document.body.scrollHeight, behavior: "smooth" });
  }
  useEffect(() => {
    if (showSuccessPage === true) {
      setTimeout(function () {
        scrollToBottom();
      }, 1000);
      setTimeout(function () {
        setShowSuccessPage(false);
      }, 4000);
    }
    // Scroll to top on component mount
  }, [showSuccessPage]);

  useEffect(() => {
    if (
      productDetailsApi &&
      productDetailsApi !== null &&
      param.id !== productDetailsApi?.Data?.ProductId
    ) {
      dispatch(resetProductDetailState());
    }
  }, [dispatch, param.id, productDetailsApi]);

  useEffect(() => {
    if (reloadOnNewCreation) {
      setReloadOnNewCreation(false);
      setShowCreateNewSkus(false);
    }
    dispatch(
      fetchSkuListData({
        search: paginationObj.searchText,
        productId: productId || "", // Replace with actual product ID
        page: paginationObj.currentPage,
        record: paginationObj.pageSize,
        sortOrder: paginationObj.SortOrder,
        sortColumn: paginationObj.SortColumn,
      })
    );
  }, [productId, paginationObj, reloadOnNewCreation]);

  useEffect(() => {
    if (
      param.id !== undefined &&
      param.id !== null &&
      productDetailsApi === null
    ) {
      dispatch(
        fetchProductDetailsData({
          productId: param.id,
        })
      );
    }
  }, [dispatch, productDetailsApi, param.id]);

  const isCommericalOwner = () => {
    if (userPermissionsStatus === ApiStatus.SUCCESS && productDetailsApi !== null) {
      const productOwnerList = productDetailsApi?.Data?.ProductOwner;
      if (!productOwnerList) {
        return false;
      }
      if (productOwnerList.length > 0) {
        const skuDatabasePermission = productOwnerList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (productOwner: any) =>
            productOwner.Email.toLowerCase() === userEmailInStore.toLowerCase(),
        ).length;
        return skuDatabasePermission > 0 ? true : false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const isCommercialProxyOwner = () => {
    if (userPermissionsStatus === ApiStatus.SUCCESS && productDetailsApi !== null) {
      const proxyOwnerList = productDetailsApi?.Data?.ProxyOwner;
      if (!proxyOwnerList) {
        return false;
      }
      if (proxyOwnerList.length > 0) {
        const skuDatabasePermission = proxyOwnerList.filter(
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          (proxyOwner: any) =>
            proxyOwner.Email.toLowerCase() === userEmailInStore.toLowerCase(),
        ).length;
        return skuDatabasePermission > 0 ? true : false;
      } else {
        return false;
      }
    } else {
      return false;
    }
  };

  const isConsumptionManager = useMemo(() => {
    if (userPermissionsData.length === 0 || !userPermissionsData?.includes("sku_consumptionmgr") || isCommercialProxyOwner() || isCommericalOwner()) {
      return false;
    }
    const isProductsReadonly = userEntityData.find(userEntity => {
      return userEntity.RoleCd === "sku_consumptionmgr" && userEntity.EntityId.includes(param.id || "")
    });
    return isProductsReadonly !== undefined;

  }, [userPermissionsData, userEntityData]);

  if (isLoading || isLoadingproductDetailAPi || userPermissionsData.length === 0) {
    return <Loader />;
  }
  //@ts-ignore
  const mapedData = mapSkuListAPIDataWithFormFields(apiData?.Result);

  const productDetails =
    productDetailsApi &&
      productDetailsApi !== null &&
      productDetailsApi !== undefined
      ? productDetailsApi?.Data
      : null;

  //@ts-ignore
  const totalRecords = apiData?.TotalRecord || 0; // This should be replaced with the actual total records count from your data source

  //@ts-ignore
  const totalPages =
    apiData?.Result?.length && apiData?.Result?.length > 0
      ? Math.ceil(totalRecords / paginationObj.pageSize)
      : 0;

  const errors =
    productDetailsApi?.Data?.CommercialDescription?.trim() === "" ||
    productDetailsApi?.Data?.AssetAdvice?.trim() === "";
  return (
    <>
      <NotificationGrid
        show={errorproductDetailAPi !== null || error !== null ? true : false}
        type="error"
        message="Unexpected Error"
      />
      <section className="productPreview-container">
        <img
          src="/src/assets/images/productPreview.svg"
          alt="EY Product preview"
          style={{ display: "none" }}
        />
        <img
          src="/src/assets/images/productPreview2.svg"
          alt="EY Product preview"
          style={{ display: "none" }}
        />
        <div className="preview-header">
          <div className="preview-header-content">
            <div className="preview-header-title">Product</div>
            <div className="preview-header-heading">{productDetails?.Name}</div>
            <div className="motif-row">
              <div className="motif-col-lg-8 motif-col-md-12">
                <p className="preview-header-description">
                  {productDetails?.Description}
                </p>
              </div>
              <div className="motif-col-lg-4 motif-col-md-12">
                <div className="preview-header-button-container">
                  <MotifButton
                    size="medium"
                    type="submit"
                    variant="secondary"
                    className="preview-header-button"
                    onClick={() => setShowCreateNewSkus(true)}
                    disabled={isConsumptionManager}
                  >
                    {"Create New SKUs"}{" "}
                    {
                      <MotifIcon
                        fill="#fff"
                        stroke="#fff"
                        iconFunction={IconoirPlus}
                        title="Computer"
                        size="24"
                      />
                    }
                  </MotifButton>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="ctProductPreview-productlist-empty">
        {/*@ts-ignore*/}
        {apiData && apiData?.Result?.length === 0 && (
          <div className="ctProductPreview-productlist-empty-text">
            <div className="ctProductPreview-productlist-empty-text-description">
              No SKUs have been created for this product.
            </div>
          </div>
        )}
        {/*@ts-ignore*/}
      </section>
      <section className="ctProductPreview-skulist-container">
        {/*@ts-ignore*/}
        {apiData && apiData?.Result?.length > 0 && (
          <>
            <div className="ctProductPreview-productlist">
              {mapedData &&
                mapedData.length > 0 &&
                mapedData.map((product) => (
                  <CTProductPreviewCard
                    key={product.skuId}
                    ProductId={productId || ""}
                    Name={product.skuName}
                    statusName={product.statusName}
                    statusCd={product.statusCd}
                    rejectedMessage={product.rejectedMessage || ""}
                    Description={product.discription || ""}
                    setSelectedSku={setSelectedSku}
                    setShowUpdateSkus={setShowUpdateSkus}
                    selectedSku={product.skuId} // Pass the skuId to the card
                    disabled={isConsumptionManager}
                  />
                ))}
            </div>
            {showSuccessPage && (
              <Toast message="Sku has been updated successfully" />
            )}
            <div className="ctProductPreview-pagination">
              <CustomPagination
                currentpage={paginationObj.currentPage}
                pageSize={paginationObj.pageSize}
                disableNext={false}
                onChangePageSize={(page: number) => {
                  setPaginationObj({
                    ...paginationObj,
                    pageSize: Number(page),
                    currentPage: 1,
                  });
                }}
                onChangeNextPage={() => {
                  setPaginationObj({
                    ...paginationObj,
                    currentPage: paginationObj.currentPage + 1,
                  });
                }}
                onChangeFirstPage={() => {
                  setPaginationObj({
                    ...paginationObj,
                    currentPage: 1,
                  });
                }}
                onChangePreviousPage={() => {
                  setPaginationObj({
                    ...paginationObj,
                    currentPage: paginationObj.currentPage - 1,
                  });
                }}
                onChangeLastPage={() => {
                  setPaginationObj({
                    ...paginationObj,
                    currentPage: totalPages,
                  });
                }}
                pageSizeSelector={paginationPageSizeSelector}
                totalRecords={totalRecords}
              />
            </div>
          </>
        )}
      </section>
      {showCreateNewSkus && (
        <CreateSkuModal
          hasAnyProductError={errors}
          setShow={setShowCreateNewSkus}
          show={showCreateNewSkus}
          onSave={() => {
            setReloadOnNewCreation(true);
          }}
          redirectToProductPreview={false}
        />
      )}
      {showUpdateSkus && (
        <UpdateSkuModal
          hasAnyProductError={errors}
          setShow={setShowUpdateSkus}
          show={showUpdateSkus}
          onSave={() => {
            setReloadOnNewCreation(true);
            console.log("Sku has been updated successfully");
            setShowSuccessPage(true);
          }}
          selectedSku={selectedSku}
        />
      )}
    </>
  );
};

export default CTProductPreview;
